export default __webpack_public_path__ + "static/media/bottom-right-ellipse.6a95aa0b.svg";